module.exports = __webpack_public_path__ + "img/undraw_chat_1wo5.d8f3f719.svg";